<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <platform-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></platform-add-form>
                <platform-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></platform-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import PlatformAddForm from './forms/add/representations/WizardForm'
    import PlatformUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../platformStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            PlatformAddForm,
            PlatformUpdateForm
        },

    }
</script>
